
export function activateTab(windowId?: number, tabId?: number) {
  if (windowId && tabId) {
    chrome.windows.update(windowId, { focused: true });
    chrome.tabs.update(tabId, { active: true });
  }
}

export function closeTab(tabId?: number) {
  if (tabId) {
    chrome.tabs.remove(tabId);
  }
}

export async function hasUnsavedChanges(tabId: number): Promise<boolean> {
  try {
    const results = await chrome.scripting.executeScript({
      target: { tabId },
      func: () => {
        const inputs = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>(
          'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"]), textarea, select'
        );
        for (const el of inputs) {
          if (el instanceof HTMLInputElement) {
            if (el.type === 'checkbox' || el.type === 'radio') {
              if (el.checked !== el.defaultChecked) return true;
            } else {
              if (el.value !== el.defaultValue) return true;
            }
          } else if (el instanceof HTMLTextAreaElement) {
            if (el.value !== el.defaultValue) return true;
          } else if (el instanceof HTMLSelectElement) {
            for (const option of el.options) {
              if (option.selected !== option.defaultSelected) return true;
            }
          }
        }
        return false;
      },
    });
    return results[0]?.result === true;
  } catch {
    // Tab not injectable (chrome://, loading, file://, etc.) — treat as no unsaved changes
    return false;
  }
}


export async function openOptionsPageInWindow() {
  const optionsUrl = chrome.runtime.getURL('src/options/options.html');
  const tabs = await chrome.tabs.query({ url: optionsUrl });
  if (tabs.length > 0 && tabs[0].id && tabs[0].windowId) {
    await chrome.windows.update(tabs[0].windowId, { focused: true });
    await chrome.tabs.update(tabs[0].id, { active: true });
  } else {
    await chrome.windows.create({
      url: optionsUrl,
      type: 'popup',
      focused: true,
      width: 1024,
      height: 800,
    });
  }
}
